import { render, staticRenderFns } from "./TimeSlotsView.vue?vue&type=template&id=2fe8366a&"
import script from "./TimeSlotsView.vue?vue&type=script&charset=utf-8&lang=js&"
export * from "./TimeSlotsView.vue?vue&type=script&charset=utf-8&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports